import { ensureModuleMessages, registerModuleCatalog } from '@/shared/i18n/i18n';
import type { Locale } from '@/shared/i18n/locales';

import type * as Api from './billing-setting.api';

// Porta do módulo (U06). Entra no JS inicial (src/app/screens.ts e a rota): só o manifesto, o schema de
// busca e funções que carregam o resto por `import()`. A tela, o fio e as queries ficam em chunks próprios.

export { BILLING_SETTING_PATH, billingSettingListScreen } from './billing-setting.screen';
export { billingSettingListSearch, type BillingSettingListSearch } from './billing-setting.search';
export { billingSettingSource } from './billing-setting.options';
export type { BillingSetting, BillingSettingOption } from './billing-setting.wire';

const MODULE = 'billing-setting';

// `eager`: títulos do manifesto no ⌘K e no breadcrumb antes de a tela abrir (A07, revisão B2).
registerModuleCatalog(MODULE, (locale: Locale) => import(`./locales/${locale}.po`), {
  eager: true,
});

/** Carrega o catálogo do módulo no idioma ativo (a rota chama antes de desenhar a tela). */
export function loadBillingSettingMessages(): Promise<void> {
  return ensureModuleMessages(MODULE);
}

/** A tela da rota (`BillingSettingRouteScreen`), por `lazyScreen`. */
export const loadBillingSettingScreen = () => import('./billing-setting.page');

/** Creation form embedded by flows that also choose a billing rule. */
export const loadBillingSettingSheet = () => import('./billing-setting-sheet');

/**
 * Porta de busca de régua de cobrança para outros módulos (Cessionário, Recuperação, Nova cobrança; F0):
 * o mesmo `GET /BillingSetting` do autocomplete do legado. Carrega o fio sob demanda.
 */
export async function listBillingSettingOptions(
  ...args: Parameters<typeof Api.listBillingSettingOptions>
) {
  return (await import('./billing-setting.api')).listBillingSettingOptions(...args);
}

/** `GET /BillingSetting/{id}` (o Cessionário mostra a régua escolhida). */
export async function getBillingSetting(...args: Parameters<typeof Api.getBillingSetting>) {
  return (await import('./billing-setting.api')).getBillingSetting(...args);
}

export {
  billingSettingOptionsQuery,
  billingSettingOptionQuery,
  billingSettingQuery,
} from './billing-setting.queries';
export { billingSettingSourceForWallet } from './billing-setting.options';
